export default __webpack_public_path__ + "static/media/buy_dark.5c01fe75.svg";